<template>
    <header class="header" id="id_header">
        <div class="top_line" id="top_line">
            <div class="container">
                <div class="burger">
                    <div class="burger_line"></div>
                    <div class="burger_line"></div>
                    <div class="burger_line"></div>
                </div>
                <div class="left_side">
                    <div class="logo">
                        <router-link to="/">
                          <!--img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/top_line_logo.svg" alt=""-->
                          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/top_line_logo.png" alt="">
                        </router-link>

                    </div>

                    <div class="options">

                        <div class="select_wrap city">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/map_icon.svg"  @click="showModal('selectCity')"   alt="">
                            <select class="select" name="city" id="city"></select>
                        </div>

                        <div class="select_wrap language" style="display: none">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/icon-globe.svg" alt="">
                            <select class="select" name="language" id="language">
                                <option value="ru">RU</option>
                                <option value="en">EN</option>
                                <option value="kz">KZ</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- <div class="search">
                    <input  class="search_inp" type="text" placeholder="поиск">
                    <div class="search_logo">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/search.svg" alt="">
                    </div>

                </div>   -->
                <div class="right_side">
                    <div @click="showModal('login')" class="enter_sign_up" v-if="!auth.user">
                        <p>Вход/Регистрация</p>
                        <div class="person_icon">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/person.svg" alt="">
                        </div>

                    </div>
                    <div to="/cabinet" class="enter_sign_up" v-else>
                        <div class="exit_btn" @click="sendLogout">
                          <span>Выйти</span>
                        </div>
                        <router-link to="/cabinet" tag="div" class="lk_text">Личный кабинет</router-link>
                        <router-link to="/cabinet" tag="div" class="person_icon">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/person.svg" alt="">
                        </router-link>

                    </div>
                    <router-link tag="button" v-if="basket.amount && parseInt(basket.amount) !==0" to="/cart" class="basket_btn"><span>Корзина</span></router-link>

                </div>

            </div>
        </div>
      <!--
        <div class="header_img" id="header_img">
            <div class="container">
                <div class="header_img_logo">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/header_logo.svg" alt="header_logo">
                </div>
            </div>
        </div>-->
        <div class="header_images_box">
          <div class="main_header_bg" :style="showMap || !cat.img ? {display: 'none'} : {}">
            <img :src="cat.img" class="main_bg" />
            <div class="description">
              <h1>{{cat.title}}</h1>
            </div>
          </div>
          <div class="header_slider" :style="showMap || cat.img ? {display: 'none'} : {}" v-if="$route.meta.header === 1 && hideAll === 0">
            <!--<img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/1ru.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/2ru.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/3ru.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/4ru.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/5ru.png" />-->
            <div class="slick-slide">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/1ru.png" />
            </div>
            <div class="slick-slide">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/2ru.png" />
            </div>
            <div class="slick-slide">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/3ru.png" />
            </div>
            <div class="slick-slide">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/4ru.png" />
            </div>
            <div class="slick-slide">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/5ru.png" />
            </div>
            <!--<img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/6.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/7.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/8.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/9.png" />
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/main_page/main_page_slider/10.png" /> -->
          </div>
          <div :class="showMap ? 'map_box active' : 'map_box'" v-show="$route.meta.map === 1 && hideAll === 0">
            <div id="main_map" ref="map">

            </div>
            <div class="container" v-show="showAddress">
              <div class="city_box">
                <select class="city_input" id="map_city">
                  <option value=""></option>
                </select>
              </div>
            </div>
            <div class="container">
              <div class="map_settings">
                <p>Перемещайте курсор пальцем чтобы указать правильный адрес</p>
                <div class="submit_box" v-show="geo.address">
                  <div class="text_bg">
                    <h1>{{geo.address}}</h1>
                    <h2>Вы здесь?</h2>
                  </div>
                  <button class="menu_item_btn change_address" @click="showAddress = true">ИЗМЕНИТЬ АДРЕС</button>
                  <button class="menu_item_btn submit_address" @click="saveAddress">ДА</button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </header>
</template>

<script>
import $ from 'jquery'
import 'select2/dist/css/select2.min.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel'
import 'select2'
import axios from '@/router/http'
export default {
  name: 'headerMenu',
  props: ['city', 'auth', 'mapinit', 'basket', 'geo', 'showMap', 'cat', 'hideAll'],
  data () {
    return {
      marker: null,
      map: null,
      initAutocompleteInterval: null,
      geocoder: null,
      showAddress: false
    }
  },
  mounted () {
    let topLine = $('#top_line')
    let headerImage = $('.header_images_box').innerHeight()
    let scroll = $(window).scrollTop()
    $(window).on('scroll', function () {
      scroll = $(this).scrollTop()
      checkScroll(scroll)
    })
    function checkScroll (scroll) {
      if (scroll >= headerImage) {
        topLine.addClass('fixed')
      } else {
        topLine.removeClass('fixed')
      }
    }
    setTimeout(() => {
      checkScroll(scroll)
    }, 3000)
    let self = this
    $('#city').select2({
      width: '100%',
      ajax: {
        url: 'https://lk.when-hungry.com/site/search-city',
        data: (params) => {
          params.id = this.city.country_id
          params.q = params.term
          params.all = 0
          params.country = 1
          params.comm = 1
          return params
        },
        dataType: 'json',
        processResults: function (data) {
          return {
            results: $.map(data, function (key, item) {
              return {
                text: key,
                id: item
              }
            })
          }
        }
      }
    }).on('select2:select', function () {
      self.city.name = $(this).select2('data')[0].text
      self.city.id = $(this).val()
    })
    $('#map_city').select2({
      allowClear: false,
      width: '100%',
      ajax: {
        url: 'https://lk.when-hungry.com/mobile/autocomplete',
        data: (params) => {
          params.input = params.term
          params.lat = this.geo.lat
          params.lng = this.geo.lng
          params.uid = this.auth.uid
          return params
        },
        dataType: 'json',
        processResults: function (data) {
          return {
            results: $.map(data, function (key, item) {
              return {
                text: key,
                id: item
              }
            })
          }
        }
      }
    }).on('select2:select', function () {
      self.geo.address = $(this).select2('data')[0].text
      axios.get('https://lk.when-hungry.com/mobile/get-place-coord?place_id=' + $(this).val()).then(response => {
        let data = response.data
        self.marker.setPosition(new google.maps.LatLng(data.coord.lat, data.coord.lng))
        self.map.setCenter(self.marker.getPosition())
        self.map.setZoom(17)
        self.geo.lat = data.coord.lat
        self.geo.lng = data.coord.lng
        self.geo.city = data.city
      }).catch(() => {
        alert('Пожалуйста перезапустите приложение, если это повториться - попробуйте чуть позже', 'Ошибка загрузки данных')
      })
    }).on('select2:open', function () {
      let select2 = $('#map_city')
      select2.data('select2').$dropdown.addClass('map_dropdown_box')
    })
  },
  methods: {
    saveAddress () {
      var formData = new FormData()
      formData.append('lat', this.geo.lat)
      formData.append('lng', this.geo.lng)
      formData.append('address', this.geo.address)
      formData.append('country', this.auth.country)
      formData.append('city', this.geo.city)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        this.auth.setNewAdr++
        this.$root.showMap = false
        this.geo.city = response.data.city
        this.geo.lat2 = this.geo.lat
        this.geo.lng2 = this.geo.lng
        this.auth.city = response.data.city
        this.city.name = response.data.city
      })
    },
    initMap () {
      this.initAutocompleteInterval = setInterval(() => {
        if (this.$root.mapinit && typeof google !== 'undefined') {
          clearInterval(this.initAutocompleteInterval)
          this.setMap()
        }
      }, 500)
    },
    setMap () {
      this.geocoder = new google.maps.Geocoder()
      if (this.geo.lat && this.geo.lng) {
        this.map = new google.maps.Map(this.$refs.map, {
          center: new google.maps.LatLng(this.geo.lat, this.geo.lng),
          zoom: 17,
          disableDefaultUI: true
        })
        this.mapIsReady()
      } else {
        this.geocoder.geocode({
          'address': this.city.name
        }, (results, status) => {
          if (results[0]) {
            this.geo.lat = results[0].geometry.location.lat()
            this.geo.lng = results[0].geometry.location.lng()
            this.map = new google.maps.Map(this.$refs.map, {
              center: new google.maps.LatLng(this.geo.lat, this.geo.lng),
              disableDefaultUI: true
            })
            this.mapIsReady()
          }
        })
      }
    },
    mapIsReady () {
      this.marker = new google.maps.Marker({
        position: new google.maps.LatLng(this.geo.lat, this.geo.lng),
        map: this.map,
        draggable: true
      })
      google.maps.event.addListener(this.marker, 'dragend', (event) => {
        this.geocoder.geocode({'location': this.marker.getPosition()}, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              this.map.setCenter(this.marker.getPosition())
              this.map.setZoom(17)
              let json = this.getAddress(results[0].address_components)
              this.geo.address = json.address
              this.geo.lng = results[0].geometry.location.lng()
              this.geo.lat = results[0].geometry.location.lat()
            }
          }
        })
      })
    },
    getAddress (adr) {
      let city
      let i
      let country
      var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name'
      }
      var componentsForms = []
      for (i = 0; i < adr.length; i++) {
        var addressType = adr[i].types[0]
        if (addressType === 'locality') city = adr[i]['long_name']
        if (addressType === 'country') country = adr[i]['long_name']
        if (componentForm[addressType]) {
          componentsForms[addressType] = adr[i][componentForm[addressType]]
        }
      }
      if (city === 'Київ') city = 'Киев'
      if (city === 'Днипро') city = 'Днепр'
      if (city === 'Дніпро́') city = 'Днепр'
      if (city === 'Одеса' || city === undefined || city === '') {
        for (i = 0; i < adr.length; i++) {
          if (adr[i].types[0] === 'political' || adr[i].types[0] === 'administrative_area_level_1') city = adr[i]['long_name']
        }
      }
      let address = [([componentsForms['route'], componentsForms['street_number']].join(' ') === ' ' ? ', ' : [componentsForms['route'], componentsForms['street_number']].join(' ')), componentsForms['administrative_area_level_1'], componentsForms['locality']].join(', ').replaceAll(', , , ', '').replaceAll(', , ', '').replaceAll(', ,', ',')
      return {city: city, country: country, address: address}
    },
    showModal (val) {
      this.$root.modals = val
    },
    sendLogout () {
      var formData = new FormData()
      formData.append('user', null)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        window.location.href = '/'
      })
    }
  },
  watch: {
    mapinit (val) {
      if (val) {
        this.initMap()
      }
    },
    'city.id' (val) {
      if ($('#city').find("option[value='" + this.city.id + "']").length) {
        $('#city').val(this.city.id).trigger('change')
      } else {
        var newOption = new Option(this.city.name, this.city.id, true, true)
        $('#city').append(newOption).trigger('change')
      }
      if (this.city.name !== this.auth.city) {
        this.geo.lat = null
        this.geo.lng = null
        this.geo.lat2 = null
        this.geo.lng2 = null
        this.geo.address = null
        this.geo.city = this.city.name
        var formData = new FormData()
        formData.append('lat', null)
        formData.append('lng', null)
        formData.append('address', null)
        formData.append('country', this.auth.country)
        formData.append('city', this.city.name)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-mobile',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  }
}
// eslint-disable-next-line
String.prototype.replaceAll = function (search, replace) {
  return this.split(search).join(replace)
}
</script>

<style scoped>
    .select2-container--default .select2-selection--single {background-color: #FF7C1D;}
    .header .header_images_box .map_box {display: none}
    .header .header_images_box .map_box.active {display: block}
</style>



// WEBPACK FOOTER //
// src/components/headerMenu.vue